import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { DataLineageDiagramState } from './data-lineage-diagram.model';
import { DataLineageDiagramStore } from './data-lineage-diagram.store';

@Injectable({ providedIn: 'root' })
export class DataLineageDiagramQuery extends Query<DataLineageDiagramState> {
  constructor(store: DataLineageDiagramStore) {
    super(store);
  }

  public readonly activeNode$ = this.select((st) => st.activeNode);
  public readonly dataLoading$ = this.select((st) => st.dataLoading);
  public readonly outputModel$ = this.select((st) => st.outputModel);
  public readonly inputModel$ = this.select((st) => st.inputModel);
  public readonly selectedFilters$ = this.select((st) => st.filters);
  public readonly selectedHighlights$ = this.select((st) => st.highlights);
}
